export default __webpack_public_path__ + "static/media/KK_logo_keskitetty_sf_swe_rgb_white.e181e08c.png";